import {DataTypeSubformProps} from "../DataTypeSubformProps";

export default function EmptySubform(props: DataTypeSubformProps) {
    return null;
}